import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Modal, Button } from "react-bootstrap";

const DeleteProjectModal = ({ show, onClose, project, members = [] }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const handleDelete = async () => {
    const token = localStorage.getItem("auth_token");
    setLoading(true);
    setError(null);

    try {
      const response = await fetch(
        `https://loopsneller.com/api/projects/${project.id}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error("Failed to delete project");
      }

      // Redirect to dashboard
      navigate("/dashboard");
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Delete Project</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          Are you sure you want to <strong>permanently delete</strong> the
          project <strong>"{project.name}"</strong>? This action cannot be
          undone.
        </p>
        <p>
          This will also delete the project for the following members:
          <ul className="mt-2">
            {members.length === 0 && <li>No members assigned.</li>}
            {members.map((member) => (
              <li key={member.id}>
                {member.user.name} ({member.role})
              </li>
            ))}
          </ul>
        </p>

        {error && <div className="alert alert-danger">{error}</div>}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose} disabled={loading}>
          Cancel
        </Button>
        <Button variant="danger" onClick={handleDelete} disabled={loading}>
          {loading ? "Deleting..." : "Delete Project"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteProjectModal;
